<template>
  <v-container fluid>
    <v-row v-if="production.productionDetails.length > 0" class="my-3">
      <span class="title">
        {{ $t('tractProduction') }}
      </span>
    </v-row>
    <v-row
    v-for="(productionDetail, index) in production.productionDetails"
    dense
    :key="`production-${production.producerId}-${index}`"
    >
      <v-col cols="12">
        <span class="subtitle-1 black--text">{{productionDetail.tractName}}</span>
      </v-col>
      <v-col cols="12">
        <DataTable
        :items.sync="productionDetail.tractProduction"
        :headers="headers"
        :propDense="true"
        :customCells="customCells"
        :hideHeader="true"
        :actions=[]>
          <template #weight="{item}">
              {{tonStringFromPounds(item.weight)}}
          </template>
          <template #amount="{item}">
            {{formatMoney(item.amount)}}
          </template>
          <template #rate="{item}">
            {{getRate(item)}}
          </template>
          <template #profit-loss="{item}">
            <span :style="`color: ${item.pl < 0 ? 'error' : 'black'}`">
              {{getPLString(item.pl)}}
            </span>
          </template>
          <template #body.append>
            <tr class="font-weight-bold">
              <td class="text-left">{{$t('totals')}}</td>
              <td></td>
              <td class="text-right">{{ getTotalLoads(productionDetail.tractProduction)}}</td>
              <td class="text-right">{{ getTotalWeight(productionDetail.tractProduction) }}</td>
              <td class="text-right">{{ getTotalAmount(productionDetail.tractProduction) }}</td>
            </tr>
          </template>
        </DataTable>
      </v-col>
    </v-row>

    <!-- log Yard Sales -->
    <v-row v-if="production.logYardSaleDetails?.length > 0" class="my-3">
      <span class="title">
        {{ $t('logYardSalesProduction') }}
      </span>
    </v-row>
    <v-row
    v-for="(lysDetail, index) in production.logYardSaleDetails"
    dense
    :key="`production-${production.fromAccountId}-${index}`"
    >
      <v-col cols="12">
        <span class="subtitle-1 black--text">{{lysDetail.fromAccountName}}</span>
      </v-col>
      <v-col cols="12">
        <DataTable
        :items.sync="lysDetail.productSummaries"
        :headers="headers"
        :propDense="true"
        :customCells="customCells"
        :hideHeader="true"
        :actions=[]>
          <template #weight="{item}">
              {{tonStringFromPounds(item.weight, 3, useMetricTons)}}
          </template>
          <template #amount="{item}">
            {{formatMoney(item.amount)}}
          </template>
          <template #rate="{item}">
            {{getRate(item)}}
          </template>
          <template #profit-loss="{item}">
            <span :style="`color: ${item.pl < 0 ? 'error' : 'black'}`">
              {{getPLString(item.pl)}}
            </span>
          </template>
          <template #body.append>
            <tr class="font-weight-bold">
              <td class="text-left">{{$t('totals')}}</td>
              <td></td>
              <td class="text-right">{{ getTotalLoads(lysDetail.productSummaries)}}</td>
              <td class="text-right">{{ getTotalWeight(lysDetail.productSummaries) }}</td>
              <td class="text-right">{{ getTotalAmount(lysDetail.productSummaries) }}</td>
            </tr>
          </template>
        </DataTable>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { tractProductionHeaders } from '@/headers/Cycles.js'
import { tonStringFromPounds, formatMoney } from '@/utils/NumericMutations.js'
import { mapGetters } from 'vuex/dist/vuex.common.js'
import { NumericConstants } from '@/utils/constants.js'
export default {
  name: 'ProductionCard',

  props: {
    production: {
      type: Object,
      required: true
    }
  },

  components: {
    DataTable: () => import('@/components/core/table/DataTable.vue')
  },

  data: () => ({
    customCells: [
      {
        slotName: 'weight',
        value: 'weight'
      },
      {
        slotName: 'amount',
        value: 'amount'
      },
      {
        slotName: 'profit-loss',
        value: 'pl'
      },
      {
        slotName: 'rate',
        value: 'rate'
      }
    ]
  }),

  computed: {
    ...mapGetters('settlements', ['useMetricTons']),
    headers () {
      return tractProductionHeaders(this.$i18n.locale)
    }
  },

  methods: {
    tonStringFromPounds,
    formatMoney,

    getTotalAmount (production) {
      return formatMoney(production.reduce((a, b) => a + b.amount, 0))
    },

    getTotalLoads (production) {
      return production.reduce((a, b) => a + b.loads, 0)
    },

    getTotalWeight (production) {
      return tonStringFromPounds(production.reduce((a, b) => a + b.weight, 0), 3, this.useMetricTons)
    },

    getRate ({ amount, weight }) {
      const divisor = this.useMetricTons ? NumericConstants.MetricTonDivisor : NumericConstants.ShortTonDivisor
      return formatMoney(amount / (weight / divisor).toFixed(2))
    }
  }
}
</script>
